<template>
  <div></div>
</template>
<script>
import protoComponent from './proto'
import { wgs2gcj, gcj2wgs } from '@/util/map/proj'

export default {
  name: 'SlAmapHeatmap',
  extends: protoComponent,
  data() {
    return {
      polyline: null,
      polygon: null,
      Circle: null,
      rectangle: null,
      ellipse: null,
      marker: null,
      SimpleMarkerData: [],
      heatmap: null
    }
  },

  props: {
    center: {
      type: Array,
      class: 'latlng'
    },
    cs: {
      type: String,
      default: 'gcj02'
    },
  },
  mounted() {
    setTimeout(() => {
      this.initHeatmap()
    }, 500)
  },
  methods: {
    $initComponent(options) {

    },
    $setCenter(v) {

    },
    $convCenter(v) {
      if (v) {
        return new AMap.LngLat(...(this.cs == 'wgs84' ? wgs2gcj(...v) : v))
      } else {
        return undefined
      }
    },
    clearShape() {
      let map = this.$amap
    },
    initHeatmap() {

    },
    /**
    高德热力图
    */
    setData(heatmapData) {
      setTimeout(() => {
        this.renderHeatmap(heatmapData)
      }, 200)
    },
    renderHeatmap(heatmapData) {
      let map = this.$amap
      map.setMapStyle('amap://styles/whitesmoke')
      map.plugin(["AMap.Heatmap"], () => {
        //初始化heatmap对象
        this.heatmap = new AMap.Heatmap(map, {
          radius: 25, //给定半径
          opacity: [0, 0.8]
        });
        this.heatmap.setDataSet({
          data: heatmapData,
          max: 100
        });
        this.setFitView()
      });
    },

    /**
    自动适配到合适视野范围
    */
    setFitView() {
      let map = this.$amap
      // 自动适配到合适视野范围
      // 无参数，默认包括所有覆盖物的情况
      map.setFitView();
    },
  },
  destroyed() {

  },
  beforeDestroy() {

  }
};

</script>
<style>
.amap-marker-label {
  border: 0;
  background-color: transparent;
}

</style>
